"use client";

import { useRouter } from "next/router";
import Link, { LinkProps } from "next/link";
import React, { PropsWithChildren, useState, useEffect } from "react";
import { usePathname } from "next/navigation";

type ActiveLinkProps = LinkProps & {
  className?: string;
  activeClassName: string;
  inactiveClassName?: string;
};

const ActiveLink = ({
  children,
  activeClassName,
  inactiveClassName = '',
  className,
  ...props
}: PropsWithChildren<ActiveLinkProps>) => {
  const pathname = usePathname();
  const [computedClassName, setComputedClassName] = useState(className);

  useEffect(() => {
    const linkPathname = new URL(
      (props.as || props.href) as string,
      location.href
    ).pathname;
    const activePathname = new URL(pathname, location.href).pathname;
    const newClassName =
      linkPathname === activePathname
        ? `${className} ${activeClassName}`.trim()
        : `${className} ${inactiveClassName}`.trim();
    if (newClassName !== computedClassName) {
      setComputedClassName(newClassName);
    }
  }, [
    pathname,
    props.as,
    props.href,
    activeClassName,
    className,
    computedClassName,
  ]);

  return (
    <Link className={computedClassName} {...props}>
      {children}
    </Link>
  );
};

export default ActiveLink;
